import { render, staticRenderFns } from "./asset_detail.vue?vue&type=template&id=4468b43f"
import script from "./asset_detail.vue?vue&type=script&lang=js"
export * from "./asset_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports